import url from "@/rest/url";
import isEmpty from '@/mixins/isempty';
import { v1 as uuidv1 } from 'uuid';
import axios from "axios";
import i18n from "@/i18n/i18n";
import pdm from "@/rest/pdm";
import {router} from "@/main"


// TODO httpClient auslagern
let httpClient = axios.create();
httpClient.defaults.timeout = 100000;


const actions = {

    initModelByMaxStklId({dispatch}, payload) {
        return new Promise(resolve => {
            if (!payload.maxStklId)
                return;

            let restUrl = '/' + payload.maxStklId + ((payload.reset)? '?reset=true' : '');
            dispatch('initModel', restUrl).then( response => {
                return resolve(response)
            });
        })

    },

    initModelBySizeType({dispatch}, payload) {
        return new Promise( resolve => {
            if (!payload.type || !payload.size)
                return;
            let restUrl = '/type/' + payload.type + '/size/' + payload.size;
                dispatch('initModel', restUrl).then( response =>{
                 return resolve(response)
                }
            )
        });
    },

    initModelByArticleNo({dispatch}, payload) {
        return new Promise( resolve => {
            if (!payload.articleNumber || !payload.deliveryCondition)
                return;

            let restUrl = '/articleNo/' + payload.articleNumber + '/deliveryCondition/' + payload.deliveryCondition + '?toConfigure=' + payload.toConfigure;
            dispatch('initModel', restUrl).then( response => {
                return resolve(response)
                }
            );
        })

    },

    initModel({state, commit}, urlParams) {
        return new Promise( (resolve) => {
            const ua = window.navigator.userAgent;
            const msie = ua.indexOf("MSIE ");
            if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv:11\./)) {
                commit('setNotificationContent', {variant: 'warning',title:  i18n.t('browser.title'), text: i18n.t('browser.text'), dontHide: true});
                commit('showNotification');
            }
            if (navigator.userAgent.match(/Edge\//)) {
                commit('setNotificationContent', {variant: 'warning', title:  i18n.t('edge.title'), text: i18n.t('edge.text'), dontHide: true});
                commit('showNotification');
            }
            console.info("initModel: " + urlParams + " " +  state);
            let restUrl = url.apiLocation + '/standard/initModel' + urlParams;
            let loadingFlag = uuidv1();
            commit('setLoadingFlag', loadingFlag);
            httpClient.get(restUrl, {
                headers: {
                    'Accept': 'application/json',
                    'Accept-Language': i18n.locale
                },
                // withCredentials: true
            }).then(response => {
                commit('newCsrfToken', response);
                    resolve(response.data)
                    commit('setKonfigModelAfterRequest', response.data.konfigModel);
                    if(response.data.produktGruppenName != null) {
                        commit('setProductBreadcrumb', response.data.produktGruppenName + ' / ' + state.konfigModel.i18nBenennung + ' / ' + state.konfigModel.typenSchluessel);
                    }
                    if(window._paq != undefined){
                        window._paq.push(['trackEvent', 'Konfigurator', 'Konfigurator aufgerufen', response.data.konfigModel.i18nBenennung])
                    }
            }).catch(error => {
                commit('setErrorMessage', error);
            }).finally(() => {
                commit('removeLoadingFlag', loadingFlag);
            });
        });
    },

    initProductTree({commit}, language) {
        return new Promise( (resolve) => {
            let loadingFlag = uuidv1();
            commit('setLoadingFlag', loadingFlag);
            let restUrl = url.apiLocation + '/productTreeVue/loadTree?lang=' + language;
            httpClient.get(restUrl, {
                headers: {
                    'Accept': 'application/json',
                    'Accept-Language': i18n.locale
                },
            }).then(response => {
                commit('setProductTree', JSON.parse(response.data));
                commit('removeLoadingFlag', loadingFlag)
                resolve('success')
            }).catch(error => {
                console.log(error)
                commit('removeLoadingFlag', loadingFlag)
            })
        })

    },

    setProductSizes({state, commit}, modelId) {
        //momentan gibt es nur fuer diese Produkte die groeßenangaben mit max. drehmoment
        if(modelId == '352907' || modelId == '352909' || modelId == '352911'){
            httpClient.get('/pdm_webapp/productsizes/'+ modelId +'.json', {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Accept-Language': i18n.locale,
                    'X-CSRF-TOKEN' : state.csrfToken['X-CSRF-TOKEN']
                },
            }).then(response => {
                commit('setProductSizes', response.data);
            })
        } else {
            commit('setProductSizes', {})
        }
    },

    setProductBreadcrumb({commit}, productBreadcrumb){
            commit('setProductBreadcrumb', productBreadcrumb);
    },

    setProductList({commit}, productList) {
        commit('setProductList', productList);
    },

    setDirectAccessVisibility({commit}, visible) {
        commit('setDirectAccessVisibility', visible);
    },

    setProductTreeVisibility({commit}, visible) {
      commit('setProductTreeVisibility', visible)
    },

    validateKonfigModel({state, commit}) {
        if (this.isValidating) {
            console.log('Service already called. Please wait a bit');
            return;
        }
        this.isValidating = true;
        commit('setValidating', true)
        let data = JSON.stringify(state.konfigModel);
        let loadingFlag = uuidv1();
        commit('setLoadingFlag', loadingFlag);
        httpClient.post(url.apiLocation + '/standard/validateKonfig?lang=' + i18n.locale , data, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Accept-Language': i18n.locale,
                'X-CSRF-TOKEN' : state.csrfToken['X-CSRF-TOKEN']
            },
            // withCredentials: true
        }).then(response => {
            commit('newCsrfToken', response);
            commit('dismissErrorMessage');
            commit('setKonfigModelAfterRequest', response.data.konfigModel);
            if(response.data.produktGruppenName != null) {
                commit('setProductBreadcrumb', response.data.produktGruppenName + ' / ' + state.konfigModel.i18nBenennung + ' / ' + state.konfigModel.typenSchluessel);
            }
        }).catch(error => {
            commit('setKonfigModelAfterRequest', JSON.parse(data));
            console.log(error);
            commit('setErrorMessage', error);
        }).finally(() => {
            commit('setValidating', false)
            this.isValidating = false;
            commit('removeLoadingFlag', loadingFlag);
        })
    },

    resetKonfigModel({dispatch, state}) {
        return dispatch('initModelByMaxStklId', {maxStklId: state.konfigModel.maxStuckelistenId, reset:true});
    },

    updateTypenschluessel({ commit, dispatch }, typenschluessel) {
        commit('setKonfigModelTypenschluessel', typenschluessel);
        commit('setKonfigModelValidationMode',  'TYPEN_SCHLUESSEL');
        dispatch('validateKonfigModel');
    },
    updateSize({dispatch, state}, payload) {
        return dispatch('initModelBySizeType',
            {type: state.konfigModel.typenSchluessel, size: payload.size});
    },



    getUserDataWithOptionalAuthentication({commit, /*state,*/ dispatch}) {
        return new Promise((resolve) => {
        let loadingFlag = uuidv1();
        commit('setLoadingFlag', loadingFlag);
        //if (isEmpty.methods.isEmpty(state.userData)){
            return dispatch('getUserData', true).then(userData => {
                if (userData) {
                    if(window._paq != undefined && userData.eMailAdresse != null && userData.eMailAdresse.length > 0){
                        window._paq.push(['setUserId', userData.eMailAdresse.toLowerCase()])
                        window._paq.push(['trackPageView'])
                    }
                    commit('setUserData', userData);
                    resolve('success');
                } else {
                    dispatch('getUserData', false).then(userData => {
                        if(window._paq != undefined && userData.eMailAdresse != null && userData.eMailAdresse.length > 0){
                            window._paq.push(['setUserId', userData.eMailAdresse.toLowerCase()])
                            window._paq.push(['trackPageView'])
                        }
                        commit('setUserData', userData);
                        resolve('success');
                    }).catch(error => {
                        console.log(error);
                        commit('setErrorMessage', error);
                        resolve('error')
                    });
                }
            }).catch((error) => {
                console.log(error);
                throw error;
            }).finally(() => {
                commit('removeLoadingFlag', loadingFlag);
            });
        //}
        //commit('removeLoadingFlag', loadingFlag)

        // if (!getUserData({commit}, true)) {
        //     getUserData({commit}, false);
        // }
        });
    },


    getUserData({commit}, authentication) {
        return new Promise((resolve) => {

            httpClient.get(url.apiLocation + '/profile/' + ((authentication)?  'getAuthenticatedUser' : 'getUser'), {
                headers: {
                    'Accept': 'application/json',
                    'Accept-Language': i18n.locale
                }
                // withCredentials: true
            }).then(response => {
                commit('newCsrfToken', response);
                let type = response.headers['content-type'];
                if (type && type.startsWith("application/json")) {
                    resolve(response.data);
                } else {
                    resolve(null);
                }

            }).catch(() => {
                // throw error;
                resolve(null);

            }).finally(() => {
            });
        });
    },

    setUserDefaultMode({commit, state}, payload) {
        let data = '';
        if (payload) {
            data = 'MODUS_EXPERT'
        } else {
            data = 'MODUS_STANDARD'
        }

        let loadingFlag = uuidv1();
        commit('setLoadingFlag', loadingFlag);
        httpClient.post(url.apiLocation + '/profile/setDefaultMode', data, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'text/plain',
                'Accept-Language': i18n.locale,
                'X-CSRF-TOKEN' : state.csrfToken['X-CSRF-TOKEN']
            }
        }).then(response => {
            commit('newCsrfToken', response);
            commit('setUserData', response.data);
        }).catch(error => {
            console.log(error);
            commit('setErrorMessage', error);
        }).finally(() => {
            commit('removeLoadingFlag', loadingFlag);
        });
    },
    drawingsByMail({state, commit}) {
    let data = JSON.stringify(state.konfigModel);
    let loadingFlag = uuidv1();
    commit('setDownloadFlag', loadingFlag);
        httpClient.post(url.apiLocation + '/drawingsByMail', data, {
            headers: {
                // 'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Accept-Language': i18n.locale,
                'X-CSRF-TOKEN' : state.csrfToken['X-CSRF-TOKEN']
            }
        }).then(response => {
            commit('newCsrfToken', response);
            commit('removeDownloadFlag', loadingFlag);
            commit('setNotificationContent', {variant: 'success', title: i18n.t('product-overview.requestSuccessHeader'), text: i18n.t('product-overview.requestSuccess'), dontHide: false});
            commit('showNotification');
        }).catch(error => {
            console.log(error);
            commit('setErrorMessage', error);
        }).finally(() => {
            commit('removeLoadingFlag', loadingFlag);
        });
    },
    downloadDrawing({state, commit}, payload) {
        let data = JSON.stringify(state.konfigModel);
        let loadingFlag = uuidv1();
        commit('setDownloadFlag', loadingFlag);
        httpClient.post(url.apiLocation + '/downloadDrawing?filetype=' + payload.type, data, {
        // httpClient.post('http://localhost:8080/pdm_webapp/downloadDrawing?filetype=' + payload.type, data, {
            responseType: 'arraybuffer',
            timeout: 150000,
            headers: {
                'Content-Type': 'application/json',
                //'Accept-Langauge': (this.$i18n)? this.$i18n.locale : 'de',
                'X-CSRF-TOKEN' : state.csrfToken['X-CSRF-TOKEN'],
                'Accept-Language': i18n.locale
                // 'Accept-Language': (this.$i18n)? this.$i18n.locale : 'de'
            }
        }, ).then((response) => {
            commit('newCsrfToken', response);
            var filename = response.headers["filename"] !== undefined ? response.headers["filename"] : 'test.pdf';
            var type = response.headers["content-type"];
            var blob = new Blob([response.data], { type: type });
            var tmpUrl = window.URL || window.webkitURL;
            var downloadUrl = tmpUrl.createObjectURL(blob);
            if (filename) {
                commit('removeDownloadFlag', loadingFlag);
                var a = document.createElement("a");
                if(window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else if (typeof a.download === 'undefined') {
                    window.location = downloadUrl;
                } else {
                    a.href = downloadUrl;
                    a.download = filename;
                    document.body.appendChild(a);
                    a.click();
                }
            } else {
                window.location = downloadUrl;
            }
        }).catch((response) => {
            // alert(JSON.stringify(response))
            commit('removeDownloadFlag', loadingFlag);
            commit('setNotificationContent', {variant: 'danger', title: 'Fehler', text: response.message, dontHide: false});
            commit('showNotification');
        });
    },
    saveKonfigForQuotation({state, commit}, requestModel) {
        requestModel.konfigModel = state.konfigModel;
        httpClient.post(url.apiLocation + '/saveKonfig', requestModel, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
               // 'Accept-Langauge': (this.$i18n)? this.$i18n.locale : 'de',
                'X-CSRF-TOKEN' : state.csrfToken['X-CSRF-TOKEN'],
                'Accept-Language': i18n.locale
                //'Accept-Language': (this.$i18n)? this.$i18n.locale : 'de'
            }
        }).then((response) => {
            commit('newCsrfToken', response);
            // alert (response.status)
            if (response.status === 200) {
                commit('setNotificationContent', {variant: 'success', title: i18n.t('product-overview.requestSuccessHeader'), text: i18n.t('product-overview.requestSuccess'), dontHide: false});
                commit('showNotification');
            }
        }).catch((response) => {
            // alert(JSON.stringify(response))
            commit('setNotificationContent', {variant: 'danger', title: 'Fehler', text: response.message, dontHide: false});
            commit('showNotification');
        });
    },
    saveInquiry({state, commit}, requestModel) {
        requestModel.konfigModel = state.konfigModel;
        httpClient.post(url.apiLocation + '/saveInquiry', requestModel, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                // 'Accept-Langauge': (this.$i18n)? this.$i18n.locale : 'de',
                'X-CSRF-TOKEN' : state.csrfToken['X-CSRF-TOKEN'],
                'Accept-Language': i18n.locale
                //'Accept-Language': (this.$i18n)? this.$i18n.locale : 'de'
            }
        }).then((response) => {
            commit('newCsrfToken', response);
            // alert (response.status)
            if (response.status === 200) {
                commit('setNotificationContent', {variant: 'success', title: i18n.t('product-overview.requestSuccessHeader'), text: i18n.t('product-overview.requestSuccess'), dontHide: false});
                commit('showNotification');
            }
        }).catch((response) => {
            // alert(JSON.stringify(response))
            commit('setNotificationContent', {variant: 'danger', title: 'Fehler', text: response.message, dontHide: false});
            commit('showNotification');
        });
    },
    isTestDatabaseEnabled({commit}){
        let restUrl = url.apiLocation + '/standard/isTestDatabaseEnabled';
        httpClient.get(restUrl).then(resp => {
            if(resp.status === 200){
                commit('setIsTestDatabaseEnabled', resp.data);
            } else {
                commit('setIsTestDatabaseEnabled', false);
            }
        }).catch(error => {
            console.log(error);
        });
    },
    isTestRulesEnabled({commit}){
        let restUrl = url.apiLocation + '/standard/isTestRulesEnabled';
        httpClient.get(restUrl).then(resp => {
            if(resp.status === 200){
                commit('setIsTestRulesEnabled', resp.data);
            } else {
                commit('setIsTestRulesEnabled', false);
            }
        }).catch(error => {
            console.log(error);
        });
    },
    showQuotationModal({state}) {
        let restUrl = url.apiLocation + '/standard/getRequestQuotationModel';
        httpClient.get(restUrl, {
            headers: {
                'Accept': 'application/json',
                'Accept-Language': i18n.locale
            }
        }).then(function (response) {
            if (isEmpty.methods.isEmpty(response.data)) {
                throw new Error('No data in server response')
            }
            state.requestQuotationModel = response.data;
            state.isQuotationModalVisible = true;
        }).catch(error => {
            console.log(error);
            this.errorMessage = error;
            this.dismissCountDown = 10;
        });
    },
    showInquiryModal({state, commit}) {
        let restUrl = url.apiLocation + '/standard/getInquiryModel';
        httpClient.post(restUrl, state.konfigModel, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'X-CSRF-TOKEN' : state.csrfToken['X-CSRF-TOKEN'],
                'Accept-Language': i18n.locale
            }
        }).then(function (response) {
            commit('newCsrfToken', response);
            if (isEmpty.methods.isEmpty(response.data)) {
                throw new Error('No data in server response');
            }
            state.requestInquiryModel = response.data;
            state.isInquiryModalVisible = true;
        }).catch(error => {
            console.log(error);
            this.errorMessage = error;
            this.dismissCountDown = 10;
        });
    },
    showOverviewWithKonfigModel({state, commit}) {
        let loadingFlag = uuidv1();
        commit('setLoadingFlag', loadingFlag);
        let payload = JSON.stringify(state.konfigModel);
        pdm.overviewByKonfigModel(state.csrfToken, payload).then(response => {
            if (isEmpty.methods.isEmpty(response.data)) {
                throw new Error('No data in server response');
            }
            router.push({ name: 'Overview', params: { overviewModel: response.data} })
        }).catch(error => {
            console.log(error);
            commit('setErrorMessage', error);
        }).finally(() => {
            commit('removeLoadingFlag', loadingFlag);
        });
    },


    calcSLA({state, commit}, payload) {
        let loadingFlag = uuidv1();
        commit('setLoadingFlag', loadingFlag);
        let restUrl = url.apiLocation + '/sla/calc';
        httpClient.post(restUrl, {model: state.konfigModel, menge: payload.menge}, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'X-CSRF-TOKEN' : state.csrfToken['X-CSRF-TOKEN'],
                'Accept-Language': i18n.locale
            }
        }).then(function (response) {
            commit('newCsrfToken', response);
            if (isEmpty.methods.isEmpty(response.data)) {
                throw new Error('No data in server response');
            }
            commit('setSla', response.data)
        }).catch(error => {
            console.log(error);
            commit('setErrorMessage', error);
        }).finally(() => {
            commit('removeLoadingFlag', loadingFlag);
        });
    },

    getItemFeatures({state, commit}) {
        commit('getItemFeatures', [])

        let loadingFlag = uuidv1();
        let data = JSON.stringify(state.konfigModel);
        commit('setLoadingFlag', loadingFlag);
        let restUrl = url.apiLocation + '/standard/getItemFeatures';
        httpClient.post(restUrl, data, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'X-CSRF-TOKEN' : state.csrfToken['X-CSRF-TOKEN'],
                'Accept-Language': i18n.locale
            }
        }).then(function (response) {
            commit('newCsrfToken', response);
            if (isEmpty.methods.isEmpty(response.data)) {
                throw new Error('No data in server response');
            }
            commit('getItemFeatures', response.data)
        }).catch(error => {
            console.log(error);
            commit('setErrorMessage', error);
        }).finally(() => {
            commit('removeLoadingFlag', loadingFlag);
        });
    }
};

export default actions;